import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Bridge status helpers
export function normalizeStatus(v?: string | null) {
  return (v || "").toLowerCase();
}

/**
 * KYC полностью одобрен — пользователь может использовать все функции
 * Bridge API: approved
 * Legacy aliases: active, complete, completed, verified
 */
export function isKycApproved(status?: string | null): boolean {
  const v = normalizeStatus(status);
  return ['approved', 'active', 'complete', 'completed', 'verified'].includes(v);
}

/**
 * KYC на проверке — документы поданы, ждём решения
 * Bridge API: pending_review
 * Legacy aliases: under_review, processing, pending, submitted, review
 */
export function isKycPending(status?: string | null): boolean {
  const v = normalizeStatus(status);
  return ['pending_review', 'under_review', 'processing', 'pending', 'submitted', 'review'].includes(v);
}

/**
 * KYC не завершён — пользователь начал но не закончил
 * Bridge API: not_started, incomplete
 * Legacy aliases: none, draft
 */
export function isKycIncomplete(status?: string | null): boolean {
  const v = normalizeStatus(status);
  return ['not_started', 'incomplete', 'none', 'draft', ''].includes(v) || !v;
}

/**
 * KYC заблокирован — требуется действие пользователя
 * Bridge API: rejected, expired
 * Legacy aliases: hold, failed
 */
export function isKycBlocked(status?: string | null): boolean {
  const v = normalizeStatus(status);
  return ['rejected', 'expired', 'hold', 'failed'].includes(v);
}

export function isTosAccepted(status?: string | null, hasAccepted?: boolean | null) {
  const v = normalizeStatus(status);
  // According to Bridge API and database: tos_status can be "accepted" or "approved"
  // Also check hasAccepted boolean flag if provided
  return v === "accepted" || v === "approved" || hasAccepted === true;
}

